import React from 'react';
import '../css/EventModal.css';

const EventModal = ({ events, date, isOpen, onClose }) => {
  if (!isOpen || !events || events.length === 0) return null;

  const formatDate = (date) => {
    if (!date) return '';
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const getEventTypeColor = (type) => {
    const colors = {
      celebration: '#ff6b6b',
      workshop: '#4ecdc4',
      launch: '#45b7d1',
      meeting: '#96ceb4',
      default: '#95a5a6'
    };
    return colors[type] || colors.default;
  };

  const getEventTypeIcon = (type) => {
    const icons = {
      celebration: '🎉',
      workshop: '📚',
      launch: '🚀',
      meeting: '👥',
      default: '📅'
    };
    return icons[type] || icons.default;
  };

  return (
    <div className="event-modal-overlay" onClick={onClose}>
      <div className="event-modal" onClick={e => e.stopPropagation()}>
        <div className="event-modal-header">
          <h2 className="event-modal-title">
            📅 {formatDate(date)}
          </h2>
          <button className="event-modal-close" onClick={onClose}>
            ×
          </button>
        </div>
        
        <div className="event-modal-content">
          
          <h3 className="event-main-message">Events Scheduled</h3>
          
          <p className="event-description">
            You have {events.length} event{events.length !== 1 ? 's' : ''} scheduled for this day!
          </p>
          
          <div className="events-list">
            {events.map((event, index) => (
              <div key={event.id || index} className="event-item">
                <div className="event-item-header">
                  <div className="event-type-badge" style={{ backgroundColor: getEventTypeColor(event.type) }}>
                    <span className="event-type-icon">{getEventTypeIcon(event.type)}</span>
                    <span className="event-type-text">{event.type || 'Event'}</span>
                  </div>
                  <div className="event-time-badge">
                    <span className="time-icon">🕐</span>
                    <span className="time-text">{event.time}</span>
                  </div>
                </div>
                
                <h4 className="event-item-title">{event.title}</h4>
                
                {event.location && (
                  <div className="event-location">
                    <span className="location-icon">📍</span>
                    <span className="location-text">{event.location}</span>
                  </div>
                )}
                
                {event.description && (
                  <p className="event-item-description">{event.description}</p>
                )}
              </div>
            ))}
          </div>
          
          <div className="event-actions">
            <button className="event-action-btn primary" onClick={onClose}>
              <span className="btn-icon">✅</span>
              <span className="btn-text">Got it!</span>
            </button>
            <button className="event-action-btn secondary" onClick={onClose}>
              <span className="btn-icon">📅</span>
              <span className="btn-text">View Calendar</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventModal;
